import { Container, Title, Text } from '@mantine/core';
import classes from './GetInTouchSimple.module.css';

export function GetInTouchSimple() {
  return (
    <Container id="contact-form" className={classes.wrapper} size="lg">
      <Title className={classes.title}>お問い合わせはこちら</Title>

      <Container size={700} p={0}>
        <Text size="lg" c="dimmed" className={classes.description}>
        デジタルメニュー翻訳サービスに関するご質問や導入についてのご相談は、
下記フォームよりお気軽にお問い合わせください。</Text>
      </Container>

      {/* Google Forms iframe - handles form submission automatically */}
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
        <iframe 
          src="https://docs.google.com/forms/d/e/1FAIpQLSeWGfzhjxPPg-ofXdtslZDPzt_g1xafPqOx5Nagwa-6k6oHPA/viewform?embedded=true" 
          width="100%" 
          height={1026} 
          frameBorder="0" 
          marginHeight={0} 
          marginWidth={0}
          title="お問い合わせフォーム"
          style={{ maxWidth: '640px' }}
        >
          Loading…
        </iframe>
      </div>
    </Container>
  );
} 